import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';

interface IResultState {
  id: string;
  name: string;
}

const RequestGetRaces = async () => {
  const response = await configApi.get<IResultState[]>('general-records/race/?remove_pagination=true');
  return response.data;
};

export const useRequestGetRaces = () => {
  return useQuery({
    queryKey: ['get_races'],
    queryFn: RequestGetRaces,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
